import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DownloadModel } from 'src/app/shared/models/download.model';
import { DownloadService } from 'src/app/shared/services/download.service';
import { UserService } from 'src/app/shared/services/user.service';
import {Location} from '@angular/common';
//import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { DownloadEditComponent } from '../download-edit/download-edit.component';
//import { GlobalNotification} from "src/app/shared/constants/global-notification"

@Component({
  selector: 'app-download-detail',
  templateUrl: './download-detail.component.html',
  styleUrls: ['./download-detail.component.css']
})
export class DownloadDetailComponent implements OnInit {
  private sub: any;
  id: string;
  thisData : DownloadModel;
  dialogConfig = new MatDialogConfig();
  releaseNote : string;
  remark : string;

  constructor( private userService : UserService,
    private route: ActivatedRoute,
    private service : DownloadService,
    private location: Location,
   // private toastr : ToastrService,
    private dialog : MatDialog) {
      this.dialogConfig.disableClose = true;
      this.dialogConfig.autoFocus = true;
      this.dialogConfig.width = "60%";
      this.dialogConfig.minWidth="400px";
      this.dialogConfig.maxWidth="800px";
  }

  ngOnInit() {

    this.sub = this.route.params.subscribe(params => {
      // this.id = +params['id']; // (+) converts string 'id' to a number
       this.id = params['id'];

       console.log("id : " + this.id);

       if(this.id != null)
       {
        this.loadData();
       }
       // In a real app: dispatch action to load the details here.
    });
  }

  loadData()
  {
    this.service.getData(this.id).subscribe(
      res=>{
        this.thisData = res as DownloadModel;
       // this.releaseNote = decodeURIComponent(this.thisData.releaseNote).replace(/\+/g, " ").replace(/\r/g, "<br/>");
       // this.remark = decodeURIComponent(this.thisData.remark).replace(/\+/g, " ").replace(/\r/g, "<br/>");

      },
      err=>{
      },
      ()=>{
         console.log("finalize");
         if(this.thisData == null) this.location.back();
      }
    );
  }

  onEdit()
  {
    this.service.populateForm(this.thisData);
    this.dialogConfig.data = {
      result : false
    };

    let dialogRef = this.dialog.open(DownloadEditComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {

      if(this.dialogConfig.data.result)
      {
        console.log(true);
        this.loadData();
      }

    });

  }
}
